import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { VeiculoVendidoDetalhadoService } from './veiculo-vendido-detalhado.service';
import { Location } from '@angular/common';
import { Table } from 'primeng/table';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs-compat/operator/filter';
import { VeiculoVendidoService } from '../veiculo-vendido/veiculo-vendido.service';

@Component({
  selector: 'app-veiculo-vendido-detalhado',
  templateUrl: './veiculo-vendido-detalhado.component.html',
  styleUrls: ['./veiculo-vendido-detalhado.component.scss']
})
export class VeiculoVendidoDetalhadoComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;

  registros: any[];
  hasHistory: any;

  columns: any[];
  _selectedColumns: any[];

  numero_nfe: string;
  serie: string;
  id_dealer: string;
  nomeModulo: string;

  displayFiltros: boolean = false;
  loading: boolean = false;

  @ViewChild('dt') dt: Table;

  filtrosHistory = {
    dealers: '',
    data_inicial: '',
    data_final: '',
    grupo_economico: '',
    situacao: '',
    marca: '',
    placa: '',
    vendaDireta: ''
  }

  dadosTranslate = {
    "Nota Fiscal": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.notaFiscal",
    "Nome Cliente": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.nomeCliente",
    "CPF": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cpf",
    "Chave NFe": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.chaveNfe",
    "Logradouro": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.logradouro",
    "CEP": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cep",
    "Cidade": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cidade",
    "Estado": "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.estado"
  }

  constructor(private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private service: VeiculoVendidoDetalhadoService,
    private servico: VeiculoVendidoService,
    private fb: FormBuilder,
    private exportExcelService: ExportExcelService,
    private translate: TranslateService) {

    this.numero_nfe = this.route.snapshot.queryParams.numero_nfe;
    this.serie = this.route.snapshot.queryParams.serie;
    this.id_dealer = this.route.snapshot.queryParams.dealer;
    this.nomeModulo = "veiculo-vendido-detalhado";

    this.form = this.fb.group({
      numero_nfe: [this.numero_nfe],
      serie: [this.serie],
      id_dealer: [this.id_dealer],
      numero: [''],
      nome: [''],
      cpf: [''],
      nfe_chave: [''],
      logradouro: [''],
      cep: [''],
      cidade: [''],
      estado: [''],
      numero_nota: ['']
    });
  }

  get f() { return this.form.controls; }

  ngOnInit() {
    this.loading = true;

    this.columns = [
      { field: 'numero_nota', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.notaFiscal' },
      { field: 'nome', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.nomeCliente' },
      { field: 'cpf', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cpf' },
      { field: 'nfe_chave', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.chaveNfe' },
      { field: 'logradouro', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.logradouro' },
      { field: 'cep', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cep' },
      { field: 'cidade', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cidade' },
      { field: 'estado', header: 'relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.estado' },
    ];

    this._selectedColumns = this.columns;

    this.getaAll();
  }

  @Input() get SelectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.columns.filter(col => val.includes(col));
  }

  private getaAll() {
    this.service.getDados(this.f.numero_nfe.value, this.f.serie.value, this.f.id_dealer.value).subscribe(dados => {
      this.registros = dados.dados;

      this.registros.forEach(dados => {
        if (dados.cpf.toString().length <= 11) {
          dados.cpf = ("00000000000" + dados.cpf.toString()).slice(-11);
          dados.cpf = dados.cpf.toString().replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        } else if (dados.cpf.toString().length > 11) {
          dados.cpf = ("00000000000" + dados.cpf.toString()).slice(-14);
          dados.cpf = dados.cpf.toString().replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
        }

        dados.cep = dados.cep.toString().replace(/^([\d]{2})\.*([\d]{3})-*([\d]{3})/, "$1.$2-$3");
        // dados.cep = dados.cep.toString().replace(/^[\d]{2}.[\d]{3}-[\d]{3}/, "$1.$2-$3");
      });

      this.loading = false;
    });
  }

  public voltar() {
    window.history.back();
  }

  protected getTranslate(value) {
    return this.dadosTranslate[value];
  }

  protected translateHeader(item) {
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.notaFiscal") {
      return this.translate.currentLang == "br" ? "Nota Fiscal" : "Invoice";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.nomeCliente") {
      return this.translate.currentLang == "br" ? "Nome Cliente" : "Client Name";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cpf") {
      return this.translate.currentLang == "br" ? "CPF" : "SSN";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.chaveNfe") {
      return this.translate.currentLang == "br" ? "Chave NFe" : "NFe Key";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.logradouro") {
      return this.translate.currentLang == "br" ? "Logradouro" : "Street";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cep") {
      return this.translate.currentLang == "br" ? "CEP" : "Zip Code";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.cidade") {
      return this.translate.currentLang == "br" ? "Cidade" : "City";
    }
    if (item == "relatorioVeiculos.veiculoVendidoDetalhado.gridHeader.estado") {
      return this.translate.currentLang == "br" ? "Estado" : "State";
    }
  }

  protected translateField(item) {
    return item;
  }

  public exportExcel() {
    let registros = [];

    this.service.getDados(this.f.numero_nfe.value, this.f.serie.value, this.f.id_dealer.value).subscribe(dados => {
      registros = dados.dados;

      registros.forEach(dados => {
        if (dados.cpf.toString().length <= 11) {
          dados.cpf = ("00000000000" + dados.cpf.toString()).slice(-11);
          dados.cpf = dados.cpf.toString().replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        } else if (dados.cpf.toString().length > 11) {
          dados.cpf = ("00000000000" + dados.cpf.toString()).slice(-14);
          dados.cpf = dados.cpf.toString().replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
        }

        dados.cep = dados.cep.toString().replace(/^([\d]{2})\.*([\d]{3})-*([\d]{3})/, "$1.$2-$3");
        // dados.cep = dados.cep.toString().replace(/^[\d]{2}.[\d]{3}-[\d]{3}/, "$1.$2-$3");
      });

      if (registros.length > 0) {
        this.exportExcelService.nomeModulo = this.nomeModulo;
        this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
          let linha = {};

          this._selectedColumns.forEach(c => {
            linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
          });

          return linha;
        }));
      }
    });
  }
}
